// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4901b518","498":"446df163","703":"93b6a8e7","787":"1eed7215"}[chunkId] + ".chunk.js";
};